import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "../../helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/clients";
const apiToggleStatusEndpoint = API_BASE_URL_ENV() + "/admin/toggle-activation/client";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    toggleStatus(id) {
        return http.post(`${apiToggleStatusEndpoint}/${id}`);
    }
}
